import store from '../store/store'

export default function ConfigForm(opts={}){
    BaseConstructor.call(this)
    let {container} = opts
    let elements = {}
    let context = this

    this.hide = () =>{
        $(elements.container).removeClass('show')    
    }

    this.show = () =>{
        $(elements.container).addClass('show')
    }

    this.destroy = _ =>{
        $(elements.container).html('')
        showConfigFormHandler = _ => null
    }

    const setPosition = _ =>{

    }

    const buildOpacityControl = _ =>{
        let current = store.getOption('opacity')
        let div = context.createElement('div', 'form-floating', '')
        let label = context.createElement('label', '', 'transparência')
        let input = context.createElement('input', 'form-control')
        input.type = 'number'
        input.placeholder = 'transparência'
        input.value = current
        input.step = "0.1"
        $(div).append(input,label)
        $(elements.opacity_wrapper).append(div)
        $(input).on('change', _=>{
            input.value = isNaN(input.value) ? 1 : input.value > 1 ? 1 : input.value < 0 ?  0 : input.value
            let value = input.value

            store.setOption('opacity', value)
        })
    }

    const buildSpeedControl = _ =>{
        let current = store.getOption('speed')
        let div = context.createElement('div', 'form-floating', '')
        let label = context.createElement('label', '', 'transição')
        let input = context.createElement('input', 'form-control')
        input.type = 'number'
        input.placeholder = 'velocidade'
        input.value = current
        input.step = "0.5"
        $(div).append(input,label)
        $(elements.speed_wrapper).append(div)
        $(input).on('change', _=>{
            input.value = isNaN(input.value) ? 2 : input.value > 10 ? 10 : input.value < 0.3 ?  0.3 : input.value
            let value = input.value

            store.setOption('speed', value)
        })
    }

    const buildFixedControl = _ =>{
        let current = store.getOption('speed')
        let div = context.createElement('div', 'form-group', '')
        let label = context.createElement('label', 'ml-2', 'Fixar recente')
        let input = context.createElement('input', '')
        input.type = 'checkbox'

        $(div).append(input,label)
        $(elements.fixed_wrapper).append(div)
        
        $(input).on('change', _=>{
            store.setOption('fixed', input.checked)
            store.setOption('play', !input.checked)
        })

        store.subscribe('SET_OPTION', data=>{
             if(data.option === 'fixed'){
                 input.checked = data.value
             }
         })
    }

    let showConfigFormHandler = value =>{
        if(value){
            context.show()
        } else {
            context.hide()
        }
    }

    init()

    function init(){
        elements.container = context.createElement('div', 'timeline-config-form-container')
        elements.title = context.createElement('div', 'config-form-title',  'Configurar')
        elements.close_btn = context.createElement('div', 'config-form-closebtn',  '<span aria-hidden="true">×</span>')
        elements.opacity_wrapper = context.createElement('div', 'control-wrapper',  '')
        elements.speed_wrapper = context.createElement('div', 'control-wrapper',  '')
        elements.fixed_wrapper = context.createElement('div', 'control-wrapper',  '')

        buildOpacityControl()
        buildSpeedControl()
        buildFixedControl()

        $(elements.container).append(elements.close_btn,elements.title,elements.speed_wrapper,elements.opacity_wrapper,elements.fixed_wrapper)

        elements.container.addEventListener('mousedown', function(event) {
            event.stopPropagation();
        });

        $(elements.close_btn).on('click', _ =>{
            store.setOption('show_config_form', false)
        })

        $(container).append(elements.container)

        store.subscribe('SET_OPTION', data=>{
            if(data.option  === 'show_config_form'){
                showConfigFormHandler(data.value)
            }
        })
    }
}

ConfigForm.prototype = Object.create(BaseConstructor.prototype)